const config = {
  MODULE_NAME: 'Login',
  MODULE_PATH: '/login',
  SHOW_IN_NAV: false,
  PROTECTED: false,
};

export default config;
